import { useEffect } from 'react';
import ContainerComponent from '@/components/common/notes/show-note-forms/form-components/container-component';
import { SET_VALUE } from '@/components/common/notes/show-note-forms/dataToSendReducer';
import Input from '@mui/material/Input';

interface Props {
    value: string;
    formId: string;
    formName: string;
    formDispatch: any;
    autoFocus?: boolean;
    item: {
        label: string;
        name: string;
        placeholder: string;
        subtype: string;
        required: boolean;
        type: string;
        description: string;
    };
    readOnly: boolean;
}

const DateFieldComponent = ({
    value,
    formDispatch,
    formId,
    formName,
    autoFocus,
    item: { label, name: fieldId, placeholder, required, type, description },
    readOnly,
}: Props) => {
    useEffect(() => {
        const todayDate = new Date();
        const parseDate =
            todayDate.getFullYear() +
            '-' +
            ('0' + (todayDate.getMonth() + 1)).slice(-2) +
            '-' +
            ('0' + todayDate.getDate()).slice(-2);

        formDispatch({ type: SET_VALUE, payload: { value: parseDate, fieldId, formId } });
    }, []);

    const handleChange = ({ target: { value } }: any) => {
        formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId } });
        formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId: formName } });
    };

    return (
        <ContainerComponent label={label} required={required} description={description}>
            <Input
                sx={{
                    width: '100%',
                    fontFamily: "'Google Sans',Roboto,Arial,sans-serif",
                    fontSize: 14,
                }}
                placeholder={placeholder}
                value={value}
                type='date'
                onChange={handleChange}
                {...(type === 'textarea' ? { multiline: true, rows: 3 } : {})}
                autoFocus={autoFocus}
                disabled={readOnly}
            />
        </ContainerComponent>
    );
};

export default DateFieldComponent;
